import React from 'react';
import classNames from './ProgressCart.module.scss';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import activitiesCompletedIcon from '@/assets/svg/activities-completed.svg';

interface ProgressCartProps {
  width: string;
  height: string;
  title: string;
  titleIcon?: string;
  description: string;
  items: {
    label: string;
    value: number;
    color: string;
  }[];
  averageProgress?: number;
}

const ProgressCart = ({
  width,
  height,
  title,
  titleIcon,
  description,
  items,
  averageProgress,
}: ProgressCartProps) => {
  const { t } = useTranslation();
  return (
    <div className={classNames.card} style={{ width: width, height: height }}>
      <div className={classNames.header}>
        <div className={classNames.headerTop}>
          <div className={classNames.titleContainer}>
            <div className={classNames.title}>
              {!!titleIcon && (
                <img className={classNames.icon} src={titleIcon} alt='' aria-hidden='true' />
              )}
              <span className={classNames.text}>{title}</span>
            </div>
            <div className={classNames.description}>
              <span className={classNames.text}>{description}</span>
            </div>
          </div>
          {averageProgress !== undefined && (
            <div className={classNames.averageProgress}>
              <div className={classNames.averageValue}>
                <span className={classNames.text}>{Math.round(averageProgress)}%</span>
              </div>
              <div className={classNames.averageLabel}>
                <SVG src={activitiesCompletedIcon} height={9} width={9} />
                <span className={classNames.text}>{t('avgProgress')}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={classNames.list}>
        {items.map((item, index) => {
          const rawValue = Number(item.value);
          const clampedValue = Math.min(100, Math.max(0, rawValue));
          const valuePercent = `${clampedValue}%`;
          const isLowValue = clampedValue <= 2;
          const valueStyle = isLowValue
            ? { insetInlineStart: `calc(${valuePercent} - 2px)`, transform: 'translateY(-50%)' }
            : { insetInlineStart: `clamp(11px, ${valuePercent}, calc(100% - 11px))` };

          return (
            <React.Fragment key={`item--${index}`}>
              <div className={classNames.item}>
                <div className={classNames.label}>
                  <span className={classNames.text}>{item.label}</span>
                </div>
                <div className={classNames.progress}>
                  {item.value > 0 && (
                    <>
                      <div
                        className={classNames.progressBat}
                        style={{ width: valuePercent, background: item.color }}
                      />
                      <div className={classNames.value} style={valueStyle}>
                        <span className={classNames.valueText}>{valuePercent}</span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressCart;
